// Mock data for Kevin Hart Nation website

export const tourDates = [
  {
    id: 1,
    date: 'Jun 7th, 7:00PM',
    location: 'Greenville, SC',
    venue: 'Peace Center',
    status: 'available',
    ticketUrl: '#'
  },
  {
    id: 2,
    date: 'Jun 15th, 7:00PM',
    location: 'Augusta, GA',
    venue: 'Bell Auditorium',
    status: 'available',
    ticketUrl: '#'
  },
  {
    id: 3,
    date: 'Jun 16th, 7:00 PM',
    location: 'Dothan, AL',
    venue: 'Dothan Civic Center',
    status: 'sold-out',
    ticketUrl: '#'
  },
  {
    id: 4,
    date: 'Jun 30th, 9:00 PM',
    location: 'Atlantic City, NJ',
    venue: 'Hard Rock Etess Arena',
    status: 'available',
    ticketUrl: '#'
  },
  {
    id: 5,
    date: 'Jul 1st, 9:00 PM',
    location: 'Niagara Falls, ON',
    venue: 'Fallsview Casino Resort',
    status: 'available',
    ticketUrl: '#'
  },
  {
    id: 6,
    date: 'Jul 7th, 8:00 PM',
    location: 'Las Vegas, NV',
    venue: 'Resorts World Theatre',
    status: 'available',
    ticketUrl: '#'
  },
  {
    id: 7,
    date: 'Sep 16th, 8:30 PM',
    location: 'Vancouver, BC',
    venue: 'Brockton Oval at Stanley Park',
    status: 'available',
    ticketUrl: '#'
  },
  {
    id: 8,
    date: 'Dec 1st, 7:00 PM',
    location: 'Port Chester, NY',
    venue: 'Capitol Theatre',
    status: 'available',
    ticketUrl: '#'
  },
  {
    id: 9,
    date: 'Jan 6th, 7:00 PM',
    location: 'Coral Springs, FL',
    venue: 'Coral Springs Center for the Arts',
    status: 'available',
    ticketUrl: '#'
  },
  {
    id: 10,
    date: 'Jan 13th, 7:00 PM',
    location: 'Boston, MA',
    venue: 'Chevalier Theatre',
    status: 'sold-out',
    ticketUrl: '#'
  }
];

export const streamingContent = [
  {
    id: 1,
    title: 'Lift',
    image: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&q=80',
    link: '#'
  },
  {
    id: 2,
    title: 'Reality Check',
    subtitle: 'Available Now',
    image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&q=80',
    link: '#'
  },
  {
    id: 3,
    title: 'Real Husbands of Hollywood',
    image: 'https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?w=800&q=80',
    link: '#'
  }
];

export const navItems = [
  { name: 'Tour Dates', href: '#tour-dates' },
  { name: 'Streaming', href: '#streaming' },
  { name: 'Shop', href: '#shop' }
];